var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._b({ref:"el",staticClass:"sticky",class:{ isDragging: _vm.isDragging },attrs:{"draggable":""},on:{"dragstart":_vm.start,"dragend":_vm.end}},'div',_vm.$attrs,false),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }